import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'c-add-button',
    templateUrl: './add-button.component.html',
    styleUrl: './add-button.component.css',
    standalone: false
})
export class AddButtonComponent {
  @Input() idButton = '';
  @Input() texto: string = 'Inserte "texto"';
  @Input() icon: string = 'pi-plus';
  @Input() fixed = true;

  @Input() secondButton = false;
  @Input() secondTexto: string = 'Inserte "texto"';
  @Input() secondIcon: string = 'pi-plus';

  @Output() clickBtn = new EventEmitter<boolean>();
  @Output() clickBtnSecondary = new EventEmitter<boolean>();

  onClick() {
    this.clickBtn.emit(true);
  }

  onClickSecondary() {
    this.clickBtnSecondary.emit(true);
  }
}
